import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const loginRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('app/modules/login-core/login/login.component').then((c) => c.LoginComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(loginRoutes)],
})
export class LoginCoreModule {}
